import { jsx as a } from "react/jsx-runtime";
import { Container as o } from "./styles.js";
import { Button as n } from "../../Button/Button.js";
const r = {
  custom: "",
  today: "Today",
  yesterday: "Yesterday",
  last7Days: "Last 7 days",
  last30Days: "Last 30 days",
  lastMonth: "Last Month",
  thisMonth: "This Month",
  thisWeek: "This Week",
  lastWeek: "Last Week"
}, m = ({ periods: s, onChange: e }) => /* @__PURE__ */ a(o, { children: s.filter((t) => t !== "custom").map((t) => /* @__PURE__ */ a(n, { appearance: "accent", variant: "secondary", size: "sm", onClick: () => e(t), children: r[t] }, t)) });
export {
  m as PeriodButtons
};
//# sourceMappingURL=PeriodButtons.js.map
